import { useState, useEffect } from "react";
import { STORAGE_KEYS } from "@/config/storageKeys";
import { Download, X, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Don't show if already installed or dismissed
    if (window.matchMedia("(display-mode: standalone)").matches) return;
    if (localStorage.getItem(STORAGE_KEYS.PWA_DISMISSED)) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show after 10 seconds on the page
      setTimeout(() => setVisible(true), 10000);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === "accepted") {
      setVisible(false);
      localStorage.setItem(STORAGE_KEYS.PWA_INSTALLED, "1");
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    localStorage.setItem(STORAGE_KEYS.PWA_DISMISSED, "1");
  };

  if (!visible || dismissed || !deferredPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto"
      style={{ animation: "slideUp 0.4s ease-out" }}>
      <div className="glass rounded-2xl border border-primary/20 p-4 shadow-2xl flex items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-white font-medium">Installer Stronger Bot</p>
          <p className="text-xs text-slate-400">Accès rapide depuis votre écran d'accueil</p>
        </div>
        <Button size="sm" onClick={handleInstall} className="btn-glow bg-primary-strong hover:bg-primary-strong/90 flex-shrink-0 gap-1">
          <Download className="w-3 h-3" /> Installer
        </Button>
        <button onClick={handleDismiss} className="text-slate-400 hover:text-white flex-shrink-0">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallPWA;
